@if (
  { violations: violations$ | async, countries: countries$ | async };
  as STATE
) {
  <section class="channel-creation-form">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="resource-form">
      <article>
        <div
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          class="channel-creation-form__file-input__label"
          [ngClass]="{
            'channel-creation-form__file-input__label--hovered': isHovered()
          }"
        >
          <ng-container *ngTemplateOutlet="uploadIcon"></ng-container>

          <div class="">
            <span> Glisser le logo dans la zone ou </span>
            <span
              (click)="fileInput.click()"
              class="channel-creation-form__file-input__button"
            >
              Parcourir les fichiers
            </span>
          </div>
        </div>
      </article>

      <mat-error
        *ngIf="$any(form.get('logo'))?.getError('httpError') as httpError"
      >
        <strong>{{ httpError }}</strong>
      </mat-error>

      <div class="input-group">
        <article>
          <mat-label>Nom du support *</mat-label>
          <mat-form-field color="primary">
            <input
              formControlName="name"
              matInput
              placeholder="Nom du support"
            />
            <mat-error
              *ngIf="$any(form.get('name'))?.getError('httpError') as httpError"
            >
              <strong>{{ httpError }}</strong>
            </mat-error>
          </mat-form-field>
        </article>
        <article>
          <mat-label>Pays *</mat-label>
          <mat-form-field>
            <mat-select
              formControlName="country"
              placeholder="Sélectionner le pays"
            >
              @for (country of STATE.countries; track country.code) {
                <mat-option [value]="country.code"
                  >{{ country.name }} ({{ country.dial_code }})
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </article>
      </div>

      <article>
        <mat-label>Type de média *</mat-label>
        <mat-radio-group class="circle-radio" formControlName="mediaType">
          @for (mediaType of mediaTypes | keyvalue; track mediaType) {
            <mat-radio-button
              [value]="mediaType.key"
              class="ads-creation-form__media-type__item"
              >{{ mediaType.value }}</mat-radio-button
            >
          }
        </mat-radio-group>
      </article>

      <button
        type="submit"
        [attr.loading]="isSubmitting()"
        [disabled]="form.invalid || isSubmitting()"
        button
      >
        Enregistrer
      </button>
    </form>
  </section>
}

<input
  #fileInput
  [accept]="supportedImageExtensions"
  type="file"
  id="logo"
  hidden
  class="channel-creation-form__file-input"
  (change)="onFileChange($event)"
/>

<ng-template #uploadIcon>
  @if (logo()) {
    <img [src]="logoUrl()" [width]="74" [height]="74" alt="logo" class="" />
  } @else {
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="74"
      height="74"
      viewBox="0 0 74 74"
    >
      <g
        id="Groupe_22409"
        data-name="Groupe 22409"
        transform="translate(-643 -264.646)"
      >
        <g
          id="Upload_Area"
          data-name="Upload Area"
          transform="translate(645 266.646)"
          fill="#f6f4fa"
          stroke="currentColor"
          stroke-width="2"
          stroke-dasharray="10"
        >
          <rect width="70" height="70" rx="5" stroke="none" />
          <rect x="-1" y="-1" width="72" height="72" rx="6" fill="none" />
        </g>
        <g
          id="Icon_akar-image"
          data-name="Icon akar-image"
          transform="translate(666.223 287.869)"
        >
          <path
            id="Tracé_11346"
            data-name="Tracé 11346"
            d="M3,7.311A4.311,4.311,0,0,1,7.311,3H20.244a4.311,4.311,0,0,1,4.311,4.311V20.244a4.311,4.311,0,0,1-4.311,4.311H7.311A4.311,4.311,0,0,1,3,20.244Z"
            transform="translate(0 0)"
            fill="none"
            stroke="#917ba2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Tracé_11347"
            data-name="Tracé 11347"
            d="M14.389,11.694A2.694,2.694,0,1,1,11.694,9,2.694,2.694,0,0,1,14.389,11.694Z"
            transform="translate(-1.689 -1.689)"
            fill="none"
            stroke="#917ba2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
          <path
            id="Tracé_11348"
            data-name="Tracé 11348"
            d="M18.189,18.655,9,28.763H22.076A4.168,4.168,0,0,0,26.244,24.6v-.143a1.372,1.372,0,0,0-.528-1.067l-4.343-4.737a2.155,2.155,0,0,0-3.184.006Z"
            transform="translate(-1.689 -4.209)"
            fill="none"
            stroke="#917ba2"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  }
</ng-template>
